import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';
import Modalexpercommentbacktex from './Modalexpercommentbacktex';



export default class Commentexlist extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   commentex:[],
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                       expert_id:this.props.expert_id,
         })
      setTimeout(() => {
       
         Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectcommentforex.php?idexpert='+this.props.expert_id+'&id_send='+this.props.id_send)
        .then(res => {
          console.log(res);
       
          this.setState({ commentex: res.data})
        }) 

      }, 0);

  }

  list() {
 
      setTimeout(() => {
         Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectcommentforex.php?idexpert='+this.props.expert_id+'&id_send='+this.props.id_send)
        .then(res => {
          console.log(res);
          this.setState({ commentex: res.data})
        }) 

      }, 0);

  }



    render() {
        

        return (
            <>
           <MDBTable>
      <MDBTableHead>
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์บทความ</th>
          <th>วันที่</th>
          <th>ไฟล์ข้อเสนอแนะ</th>
          <th>วันที่ส่งกลับ</th>
          <th>สถานะ ผ่าน/ไม่ผ่าน</th>
          <th>การส่งกลับ</th>
          
        </tr>
      </MDBTableHead>
      <MDBTableBody>
                      {this.state.commentex.map((commentex,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>
                           
                            <a href={`https://edu.kpru.ac.th/conference/PHPAPI/closeacticleex/${commentex.fileword}`}  target="_blank"><p className="indigo-text"><MDBIcon far icon="file-word" /> ไฟล์ที่ส่งตรวจ</p> </a>
                            <a href={`https://edu.kpru.ac.th/conference/PHPAPI/closeacticleex/${commentex.filepdf}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> ไฟล์ที่ส่งตรวจ</p> </a>
                            </td>
                        <td>{commentex.date_sentex}</td>
                        <td>{commentex.filepdfcomment_ex !== null ? <>{commentex.filepdfcomment_ex}</>:<><MDBIcon far icon="hourglass" /></>}</td>
                        <td>{commentex.date_senbacktex !== null ?<>{commentex.date_senbacktex}</>:<><MDBIcon far icon="hourglass" /></>}</td>
                        <td>{commentex.statuscomment_ex==='1'?<>ผ่าน</>:<>
                               {commentex.statuscomment_ex==='0'?<>ไม่ผ่าน</>:<><MDBIcon far icon="hourglass" /></>}
                            </>}
                        </td>
                        <td>{commentex.statuscomment_ex !== null ?<>
                        ส่งกลับแล้ว
                        </>:<>
                          {commentex.statuscomment_ex==='1'?<>แจ้งกลับแล้ว</>:<>
                          <Modalexpercommentbacktex id_send={commentex.id_send} id_excomment={commentex.id_excomment} id_ex={commentex.id_ex} list={this.list}  />
                          </>}
                        
                        </>}
                        {}
                            
                            </td>
                        </tr>
                      )}
       
      </MDBTableBody>
    </MDBTable>
           
          </>
          
        )
    }
}


